/**
 * Formats the given duration in milliseconds into a human-readable string representation.
 *
 * @param {number} millis - The duration in milliseconds.
 * @return {string} The formatted duration string in the format "HH:MM:SS" or "MM:SS" if less than an hour.
 */
export function formatDuration(millis: number, longFormat = false) {
    const seconds = Math.floor(millis / 1000);
    let str = "";
    if (seconds < 10) {
        str = "0:0" + seconds;
    } else if (seconds < 60) {
        str = "0:" + seconds;
    } else if (seconds < 3600) {
        str = getMinutes(seconds) + ":";
        const second = getSeconds(seconds);
        str += second < 10 ? "0" + second : second;
    } else {
        str = getHours(seconds) + ":";
        const minutes = getMinutes(seconds);
        const second = getSeconds(seconds);
        str += minutes < 10 ? "0" + minutes : minutes;
        str += ":";
        str += second < 10 ? "0" + second : second;
    }
    if (longFormat) {
        const mask = "00:00:00";
        str = mask.substring(0, mask.length - str.length) + str;
    }
    return str;
}

function getSeconds(num: number): number {
    return num % 60;
}

function getMinutes(num: number): number {
    return Math.floor(num / 60) % 60;
}

function getHours(num: number): number {
    return Math.floor(num / 3600);
}

export const DateTimeUtils = {
    formatDuration,
};
